import { c as _c } from "react/compiler-runtime";
import { CheckBoxSwitcher, FieldLabel, Tooltip } from '@systemeio/ui';
import { DateSpecificAvailabilitySlots } from 'modules/calendar/availability/components/date-specific-availability-slots';
import { WeekdaysAvailabilitySlots } from 'modules/calendar/availability/components/weekdays-availability-slots';
import { useDraftAvailabilitySlots } from 'modules/calendar/availability/hooks/use-draft-availability-slots';
import { AvailabilityErrors, AvailabilitySlot } from 'modules/calendar/availability/types/availability-interface';
import { groupAvailabilities } from 'modules/calendar/availability/utils';
import { EventFormErrors } from 'modules/calendar/events/types/event-interface';
import { useEffect, useMemo } from 'react';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface EventAvailabilityProps {
  useGlobalAvailability: boolean;
  onSelectGlobalAvailability: (value: boolean) => void;
  defaultSlots?: AvailabilitySlot[];
  globalSlots?: AvailabilitySlot[];
  onChange: (updatedSlots: AvailabilitySlot[]) => void;
  checkboxError?: string;
  errors?: EventFormErrors;
  error?: string;
  isLoading?: boolean;
  minDate?: Date;
  maxDate?: Date;
}
export function EventAvailability(t0) {
  const $ = _c(49);
  const {
    useGlobalAvailability,
    onSelectGlobalAvailability,
    defaultSlots,
    globalSlots: t1,
    onChange,
    checkboxError,
    errors,
    error,
    isLoading,
    minDate,
    maxDate
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const globalSlots = t2;
  const {
    t
  } = useLocoTranslation();
  const {
    draftAvailabilitySlots,
    weekdaysSlots,
    dateSpecificSlots,
    addSlot,
    removeSlots,
    updateSlot
  } = useDraftAvailabilitySlots(defaultSlots);
  let t3;
  if ($[2] !== globalSlots) {
    t3 = groupAvailabilities(globalSlots);
    $[2] = globalSlots;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const globalAvailability = t3;
  let t4;
  bb0: {
    if (!errors) {
      t4 = undefined;
      break bb0;
    }
    let t5;
    if ($[4] !== errors) {
      const filtered = {};
      Object.entries(errors).forEach(t6 => {
        const [key, value] = t6;
        if (key.startsWith("localUserAvailability.") && value) {
          const newKey = key.slice(22);
          filtered[newKey as keyof AvailabilityErrors] = value;
        }
      });
      t5 = Object.keys(filtered).length > 0 ? filtered : undefined;
      $[4] = errors;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    t4 = t5;
  }
  const filteredErrors = t4;
  let t5;
  if ($[6] !== draftAvailabilitySlots || $[7] !== onChange) {
    t5 = () => {
      onChange(draftAvailabilitySlots);
    };
    $[6] = draftAvailabilitySlots;
    $[7] = onChange;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== draftAvailabilitySlots) {
    t6 = [draftAvailabilitySlots];
    $[9] = draftAvailabilitySlots;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== t) {
    t7 = t("dashboard.calendar.available_hours");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <FieldLabel labelClassName="mb-2" label={t7} />;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== checkboxError || $[16] !== globalSlots?.length || $[17] !== onSelectGlobalAvailability || $[18] !== t || $[19] !== useGlobalAvailability) {
    t9 = checkboxError ? <Tooltip label={checkboxError} mode="hover"><CheckBoxSwitcher label={t("dashboard.calendar.use_global_availability")} selected={useGlobalAvailability} onChange={onSelectGlobalAvailability} disabled={!globalSlots?.length} /></Tooltip> : <CheckBoxSwitcher label={t("dashboard.calendar.use_global_availability")} selected={useGlobalAvailability} onChange={onSelectGlobalAvailability} disabled={!globalSlots?.length} />;
    $[15] = checkboxError;
    $[16] = globalSlots?.length;
    $[17] = onSelectGlobalAvailability;
    $[18] = t;
    $[19] = useGlobalAvailability;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = useGlobalAvailability ? globalAvailability.weekdaysSlots : weekdaysSlots;
  let t11;
  if ($[21] !== addSlot || $[22] !== filteredErrors || $[23] !== isLoading || $[24] !== removeSlots || $[25] !== t10 || $[26] !== updateSlot || $[27] !== useGlobalAvailability) {
    t11 = <div className="mb-10 flex-1 md:pr-10"><WeekdaysAvailabilitySlots slots={t10} addSlot={addSlot} removeSlots={removeSlots} updateSlot={updateSlot} disabled={useGlobalAvailability} isLoading={isLoading} titleClassName="text-lg text-text-primary" errors={filteredErrors} /></div>;
    $[21] = addSlot;
    $[22] = filteredErrors;
    $[23] = isLoading;
    $[24] = removeSlots;
    $[25] = t10;
    $[26] = updateSlot;
    $[27] = useGlobalAvailability;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  const t12 = useGlobalAvailability ? globalAvailability.dateSpecificSlots : dateSpecificSlots;
  let t13;
  if ($[29] !== addSlot || $[30] !== filteredErrors || $[31] !== isLoading || $[32] !== maxDate || $[33] !== minDate || $[34] !== removeSlots || $[35] !== t12 || $[36] !== updateSlot || $[37] !== useGlobalAvailability) {
    t13 = <div className="border-text-secondary/30 flex-1 xl:md:border-l xl:md:pl-10"><DateSpecificAvailabilitySlots slots={t12} addSlot={addSlot} removeSlots={removeSlots} updateSlot={updateSlot} disabled={useGlobalAvailability} isLoading={isLoading} minDate={minDate} maxDate={maxDate} titleClassName="text-lg text-text-primary" errors={filteredErrors} /></div>;
    $[29] = addSlot;
    $[30] = filteredErrors;
    $[31] = isLoading;
    $[32] = maxDate;
    $[33] = minDate;
    $[34] = removeSlots;
    $[35] = t12;
    $[36] = updateSlot;
    $[37] = useGlobalAvailability;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t11 || $[40] !== t13) {
    t14 = <div className="mt-8 flex w-full flex-col xl:flex-row">{t11}{t13}</div>;
    $[39] = t11;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== error) {
    t15 = <FieldErrorAndDescription error={error} />;
    $[42] = error;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t14 || $[45] !== t15 || $[46] !== t8 || $[47] !== t9) {
    t16 = <div>{t8}{t9}{t14}{t15}</div>;
    $[44] = t14;
    $[45] = t15;
    $[46] = t8;
    $[47] = t9;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  return t16;
}